@if (!memberCode) {
  <div>
    <h1 class="p-3">No Member Information Found - verify portal login</h1>
    <div class="p-3">
      <dx-text-box style="min-width: 300px; max-width: 500px" [label]="'Member Email'" [(value)]="memberEmailSubmit"></dx-text-box>
      <dx-text-box style="min-width: 300px; max-width: 500px" [label]="'Member Code'" [(value)]="memberCodeSubmit"></dx-text-box>
      <button class="btn btn-sm btn-primary" (click)="submitMemberCode()">Submit</button>
    </div>
  </div>
}
@if (memberCode) {
  <div class="d-flex flex-fill flex-column committee-portal">

    <!-- Top toolbar -->
    <div class="portal-toolbar d-flex flex-row align-items-center gap-2 px-3">
      <button class="btn btn-sm btn-outline-secondary sidebar-toggle-btn" (click)="sidebarOpen = !sidebarOpen" title="Toggle panels">
        <span class="fa fa-bars"></span>
      </button>
      <dx-select-box
        [label]="'Committee'"
        [items]="userCommittees"
        [(value)]="selectedCommitteeId"
        valueExpr="CommitteeId"
        displayExpr="CommitteeName"
        width="250px"
        (onSelectionChanged)="onCommitteeSelectionChanged($event)"
      ></dx-select-box>
      <div class="ms-auto d-flex gap-2 align-items-center">
        @if (this.selectedAgenda && (isChair || isClerk || isAdmin)) {
          <button class="btn btn-primary btn-sm" (click)="email()" [disabled]="!hasSelectedAgenda() || hasChanges()">Email</button>
          <button class="btn btn-primary btn-sm" (click)="print()" [disabled]="!hasSelectedAgenda() || hasChanges()">Print</button>
        }
        @if (hasChanges()) {
          <button class="btn btn-sm btn-success" (click)="save()" accesskey="s" title="alt+s">Save (alt+s)</button>
          <button class="btn btn-sm btn-danger" (click)="cancel()">Cancel</button>
        }
      </div>
    </div>

    <!-- Main content area -->
    <div class="d-flex flex-fill overflow-hidden">

      <!-- Collapsible sidebar -->
      <div class="portal-sidebar" [class.portal-sidebar--collapsed]="!sidebarOpen">
        <div class="portal-sidebar__inner">

          <!-- Agendas accordion section -->
          <div class="accordion-section" [class.accordion-section--open]="agendasOpen">
            <div class="accordion-section__header" (click)="agendasOpen = !agendasOpen">
              <span>Agendas / Minutes</span>
              <span class="fa" [class.fa-chevron-down]="agendasOpen" [class.fa-chevron-up]="!agendasOpen"></span>
            </div>
            <div [hidden]="!agendasOpen" class="accordion-section__body">
              <dx-data-grid
                #agendaDataGrid
                [dataSource]="agendas"
                keyExpr="id"
                [showBorders]="true"
                [columnAutoWidth]="false"
                [focusedRowEnabled]="false"
                [showColumnLines]="true"
                [wordWrapEnabled]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onAgendaSelectionChanged($event)"
              >
                <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
                <dxi-column dataField="name" width="500"></dxi-column>
                <!-- <dxo-state-storing [enabled]="true" type="localStorage" storageKey="agenda-grid"></dxo-state-storing> -->
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-selection [mode]="'single'" showCheckBoxesMode="true"></dxo-selection>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  @if(isChair || isClerk){
                    <button class="btn btn-sm btn-primary" (click)="newAgenda()" [disabled]="!this.selectedCommittee">New</button>
                    <button class="btn btn-sm btn-primary ms-2" (click)="newAgenda(true)" [disabled]="agendaDataGrid.instance.getSelectedRowsData().length === 0">Copy</button>
                    <button class="ms-2 btn btn-sm btn-primary" (click)="editAgenda()" [disabled]="agendaDataGrid.instance.getSelectedRowsData().length === 0">Edit</button>
                    <button class="ms-2 btn btn-sm btn-danger" (click)="deleteAgenda()" [disabled]="agendaDataGrid.instance.getSelectedRowsData().length === 0">Delete</button>
                  }
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  <!-- @if (agendas) {
                    <span class="me-3">
                      <strong>{{ "Agendas " + agendaDataGrid.instance.totalCount() + " items" }}</strong>
                    </span>
                  } -->
                </div>
              </dx-data-grid>
            </div>
          </div>

          <!-- Documents accordion section -->
          <div class="accordion-section" [class.accordion-section--open]="documentsOpen">
            <div class="accordion-section__header" (click)="documentsOpen = !documentsOpen">
              <span>Uploaded Files</span>
              <span class="fa" [class.fa-chevron-down]="documentsOpen" [class.fa-chevron-up]="!documentsOpen"></span>
            </div>
            <div [hidden]="!documentsOpen" class="accordion-section__body">
              <dx-data-grid
                #dataGrid
                [dataSource]="documents"
                keyExpr="id"
                [showBorders]="true"
                [columnAutoWidth]="false"
                [focusedRowEnabled]="false"
                [showColumnLines]="true"
                [wordWrapEnabled]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChanged($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onRowPrepared)="rowPrepare($event)"
              >
                <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
                <dxi-column dataField="name" width="500"></dxi-column>
                <!-- <dxo-state-storing [enabled]="true" type="localStorage" storageKey="documents-grid"></dxo-state-storing> -->
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-selection [mode]="'single'" showCheckBoxesMode="true"></dxo-selection>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  @if(isChair || isClerk){
                    <button class="btn btn-sm btn-primary" (click)="add()">Upload</button>
                    <button class="btn btn-sm btn-danger ms-2" (click)="deleteDocument()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Delete</button>
                    <button class="btn btn-sm btn-secondary ms-2" (click)="rename()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Rename</button>

                  }
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  <!-- @if (documents) {
                    <span class="me-3">
                      <strong>{{ "Documents " + dataGrid.instance.totalCount() + " items" }}</strong>
                    </span>
                  } -->
                </div>
              </dx-data-grid>
            </div>
          </div>

        </div>
      </div>

      <!-- Editor area -->
      <div class="editor-area d-flex flex-fill flex-column px-3 pb-3 overflow-hidden">
        <dx-html-editor
          #editor
          class="ark-html-editor"
          [value]="selectedAgenda?.agendaText"
          (valueChange)="onAgendaTextChanged($event)"
          [readOnly]="!selectedAgenda || (!isChair && !isClerk)"
          [hidden]="!selectedAgenda"
        >
            <dxo-toolbar [tabIndex]="-1">
              <dxi-item name="color" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="background" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item
                name="size"
                [acceptedValues]="['8pt', '10pt', '11pt', '12pt', '14pt', '18pt', '24pt', '36pt', '72pt']"
                [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
              ></dxi-item>
              <dxi-item
                name="font"
                [acceptedValues]="['Arial', 'Calibri', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']"
                [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
              ></dxi-item>
              <dxi-item name="bold" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="italic" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="strike" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="underline" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="superscript" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="subscript" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="bulletList" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="orderedList" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="alignLeft" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="alignCenter" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="alignRight" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="alignJustify" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="increaseIndent" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="decreaseIndent" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="codeBlock" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="blockQuote" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="link" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="image" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="insertTable" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="undo" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="redo" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="separator" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="insertTable" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="deleteTable" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="insertRowAbove" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="insertRowBelow" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="deleteRow" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="insertColumnLeft" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="insertColumnRight" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="deleteColumn" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="cellProperties" [options]="{ tabIndex: -1 }"></dxi-item>
              <dxi-item name="tableProperties" [options]="{ tabIndex: -1 }"></dxi-item>
            </dxo-toolbar>
            <dxo-media-resizing [enabled]="true"></dxo-media-resizing>
            <dxo-image-upload [tabs]="['file']" fileUploadMode="base64"></dxo-image-upload>
            <dxo-table-context-menu [enabled]="true"></dxo-table-context-menu>
          </dx-html-editor>
      </div>

    </div>
  </div>
}
